// Angular dependencies.
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

// App dependencies.
import { AuthService } from '../core/upgraded-providers';
import { FeaturesService } from '../features.service';

const IS_NW = !!window.nw;

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private _router: Router,
        private _authSrv: AuthService,
        private _featuresSrv: FeaturesService
    ) {
    }

    async canActivate(): Promise<boolean> {
        await this._authSrv.check();

        // TODO: Dublicate code in src/utils/auth
        if (!this._authSrv.Me) {
            if (IS_NW) {
                if (this._featuresSrv.data['auth']) {
                    this._authSrv.signInSteamByTicket().then(() => window.location.reload());
                }
            }
            else {
                if (this._featuresSrv.data['auth']) {
                    this._router.navigateByUrl('/register');
                }
                else {
                    window.location.href = 'https://screeps.com/a/#!/register';
                }
            }

            return false;
        }
        else if(!this._authSrv.Me.username || !this._authSrv.Me.email && !this._authSrv.Me.steam && !this._authSrv.Me.github) {
            if (this._featuresSrv.data['auth']) {
                this._router.navigateByUrl('/register');

                return false;
            }
        }

        return true;
    }
}
